GP.collections.ActivityUsers = Backbone.Collection.extend({
    model:GP.models.User
});
